import { ErrorType } from "~/enums/ErrorType";
import { ValidationErrorMessage } from "~/enums/validationErrorMessage";
import { VisualizationType } from "~/enums/visualizationType";
import { ObjectHelper } from "~/helpers/objectHelper";
import ValidationError from "../validationError";
import Visualization from "../visualizations/visualization";
import NavigableValidator from "./navigableValidator";

export default class VisualizationDataPointValidator extends NavigableValidator<Visualization> {
  defaultMessage = ValidationErrorMessage.MustBeDefined;
  defaultType = ErrorType.mustBeDefined;

  protected _validate(model: Visualization): void {
    const columns = ObjectHelper.toArray(model.column_data_points);
    const rows = ObjectHelper.toArray(model.row_data_points);
    const values = ObjectHelper.toArray(model.value_data_points);


    if (model.visualization_type === VisualizationType.PivotTable) {
      if (columns.length < 1 && rows.length < 1) {
        this.errors.push(this.buildValidationError(model, 'Data Points must be defined and valid.', 'Columns or Rows', 'column_data_points'));
      }

      if (columns.length > 0 && !columns[0].isValid) {
        this.errors.push(this.buildValidationError(model, 'Data Points must be defined and valid.', 'Columns', 'column_data_points'));
      }

      if (rows.length > 0 && !rows[0].isValid) {
        this.errors.push(this.buildValidationError(model, 'Data Points must be defined and valid.', 'Rows', 'row_data_points'));
      }

      if (values.length < 1 || !values[0].isValid) {
        this.errors.push(this.buildValidationError(model, 'Data Points must be defined and valid.', 'Values', 'value_data_points'));
      }
    }

    if (model.visualization_type === VisualizationType.BarGraph) {
      if (columns.length < 1 || !columns[0].isValid) {
        this.errors.push(this.buildValidationError(model, 'Data Points must be defined and valid.', 'Y-Axis', 'column_data_points'));
      }

      if (rows.length < 1 || !rows[0].isValid) {
        this.errors.push(this.buildValidationError(model, 'Data Points must be defined and valid.', 'X-Axis', 'row_data_points'));
      }
    }

    if (model.visualization_type === VisualizationType.SummaryCard) {
      if (values.length < 1 || !values[0].isValid) {
        this.errors.push(this.buildValidationError(model, 'Data Points must be defined and valid.', 'Values', 'value_data_points'));
      }
    }
  }

  buildValidationError(model: any, value?, displayName?, validatorKey?, type?) {
    const messageFromOptions = this.options.message instanceof Function ? this.options.message(model, validatorKey) : this.options.message
    return new ValidationError({
      message: messageFromOptions || this.defaultMessage,
      displayName: displayName,
      errorNavOpts: this.errorNavOpts(model, validatorKey, value, type),
      field: validatorKey,
      type: this.options.type || type || this.defaultType,
      section: this.section,
      level: this.errorLevel,
    });
  }

}